
export default () => ({
    loading: true,
    groups: null,
    currentGroup: null,
    groupTypes: [],
    paymentsMode: [],
    totalItems: 0,
    groupsTotalParticipants: []
})